import Typography from '@components/v2/ui/Typography/Typography';
import { CardActionArea } from '@mui/material';
import { Fragment } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { BaseItem, Column } from './VirtualizedTable.types';
import { useStyles } from './virtualizedTable.styles';

interface VirtualizedCardTableContentProps<T extends BaseItem> {
  item: T;
  columns: Column<T>[];
  itemIndex: number;
  onClick?: () => void;
}

const VirtualizedCardTableContent = <T extends BaseItem>({
  item,
  columns,
  itemIndex,
  onClick,
}: VirtualizedCardTableContentProps<T>) => {
  const { translate } = useTranslation();
  const { classes } = useStyles();

  return (
    <CardActionArea disableRipple className={classes.mobileCardActionArea} onClick={onClick}>
      <div className={classes.mobileCardFields}>
        {columns.map((column) => (
          <Fragment key={column.name}>
            <Typography variant="body2" color="textSecondary" noWrap>
              {translate(column.title as LangEnum)}
            </Typography>
            <div className={classes.mobileGridItemLink}>
              {(column.cardRender ?? column.render)(item, itemIndex).node}
            </div>
          </Fragment>
        ))}
      </div>
    </CardActionArea>
  );
};

export default VirtualizedCardTableContent;
